import AgentSessionSettledToastListener from '@/components/Agents/AgentSessionReadyToast/AgentSessionSettledToastListener.tsx';
import BenchlingLinkChangedListener from '@/support/benchlingLink/BenchlingLinkChangedListener';
import ExportGeneratedToastListener from '@/components/Studies/StudyExports/ExportReadyToast/ExportGeneratedToastListener.tsx';
import { type FC } from 'react';

/**
 * Every app-wide team event listener: the toasts, and listeners that keep state in step, such as the
 * Benchling link. Mounted once in the root layout rather than per route, so a listener's state (such
 * as the session listener's open toasts) survives navigation. A new listener registers here rather
 * than in `App.tsx`.
 */
const TeamEventToasts: FC = () => (
  <>
    <ExportGeneratedToastListener />
    <AgentSessionSettledToastListener />
    <BenchlingLinkChangedListener />
  </>
);

export default TeamEventToasts;
